export default __webpack_public_path__ + "static/media/fail-icon.3ae0599d.png";